import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { types } from "../action-types";
import {getAllInterviewsApi} from "../../API/API"

function* getAllInterviewsSaga(action) {
  try {
    const response = yield call(() => getAllInterviewsApi());
    yield put({ type: types.GET_ALLINTERVIEWS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.GET_ALLINTERVIEWS_FAILURE, error });
  }
}

export function* watchGetAllInterviewsSaga() {
  yield takeLatest(types.GET_ALLINTERVIEWS_REQUESTED, getAllInterviewsSaga);
}
